export default __webpack_public_path__ + "static/media/elemento10_web.15c1df2d.png";